/**
 * Payment provider settings script
 */

let monetaryAjaxCall = undefined;

/**
 * Initialize all controls and inputs necessary to refresh
 * the monetary accounts belonging to specific payment provider settings
 *
 * @param $container
 */
const initializeMonetaryAccountRefreshing = function($container) {
    if (window.monetaryAccountsUrl === undefined) {
        return;
    }

    $container.on('click', '[data-refresh]', function() {
        if (monetaryAjaxCall !== undefined) {
            return;
        }

        let $refreshButton         = $(this);
        let provider               = $refreshButton.data('refresh');
        let $formGroup             = $refreshButton.closest('.form-group');
        let $form                  = $formGroup.closest('form');
        let $messageHolder         = $formGroup.find('[data-refresh-message]');
        let $apiKeyInput           = $form.find('input[name="cashback_settings\[' + provider + '\]\[api_key\]"]');
        let $environmentSelect     = $form.find('select[name="cashback_settings\[' + provider + '\]\[environment\]"]');
        let $monetaryAccountSelect = $form.find('select[name="cashback_settings\[' + provider + '\]\[monetary_account_id\]"]');

        let apiKey           = $apiKeyInput.val();
        let environment      = $environmentSelect.val();
        let currentAccountId = $monetaryAccountSelect.val();

        // Set loading state
        $refreshButton.find('i').addClass('fa-spin');
        $refreshButton.addClass('disabled');
        $environmentSelect.prop('disabled', true);
        $apiKeyInput.prop('disabled', true);
        $monetaryAccountSelect.prop('disabled', true);
        $messageHolder.html('').hide();

        // Execute the AJAX call to fetch all monetary accounts and possible generate an API key
        monetaryAjaxCall = $.get(window.monetaryAccountsUrl, {apiKey: apiKey, environment: environment, provider: provider})
            .done(function(data) {
                // Fill the API key if one was generated for a sandbox environment
                if (data.apiKey && data.apiKey.length > 0 && apiKey.length === 0) {
                    $apiKeyInput.val(data.apiKey);
                }

                // Populate monetary accounts in dropdown
                $monetaryAccountSelect.html('');
                for (var id in data.monetaryAccounts) {
                    if (data.monetaryAccounts.hasOwnProperty(id)) {
                        $monetaryAccountSelect.append($('<option>', {value: id, text: data.monetaryAccounts[id]}));
                    }
                }

                // Select previous account or first new account
                if (data.monetaryAccounts.hasOwnProperty(currentAccountId)) {
                    $monetaryAccountSelect.val(currentAccountId)
                } else {
                    $monetaryAccountSelect.val(Object.keys(data.monetaryAccounts)[0]);
                }

                // Trigger a change for DOM updates
                $monetaryAccountSelect.trigger('change');
            }).fail(function() {
                // Clear all options from the monetary accounts
                $monetaryAccountSelect.html('').trigger('change');
            }).always(function(data) {
                // Reset loading state
                $refreshButton.removeClass('disabled');
                $refreshButton.find('i').removeClass('fa-spin');
                $environmentSelect.prop('disabled', false);
                $apiKeyInput.prop('disabled', false);
                $monetaryAccountSelect.prop('disabled', false);
                monetaryAjaxCall = undefined;

                // Show a message if it is given
                if (data.responseJSON !== undefined) {
                    data = data.responseJSON;
                }
                if (data.message && data.message.length > 0) {
                    $messageHolder.html(data.message).show();
                }
            });
    });
};

/**
 * Initialization of payment provider configuration settings
 *
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    let $refreshButtons = $('.btn[data-refresh]', $container);
    if ($refreshButtons.length > 0) {
        initializeMonetaryAccountRefreshing($refreshButtons.first().closest('form'));
    }
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/payment_providers.js